export default [
    {
        name: "Batu 16",
        lat: 3.3093984499999993,
        lng: 101.5952929,
    },
    {
        name: "Kg. Sg. Serai",
        lat: 3.1838827999999997,
        lng: 101.70590955,
    },
    {
        name: "Batu 10 Cheras",
        lat: 3.05817505,
        lng: 101.77695,
    },
    {
        name: "Kg. Batu 9",
        lat: 2.64801005,
        lng: 102.05275499999999,
    },
    {
        name: "Sg. Sikamat",
        lat: 3.02321855,
        lng: 101.78017695,
    },
    {
        name: "Kg. Pasir",
        lat: 2.9979795,
        lng: 101.87335459999998,
    },
    {
        name: "Kg. Sentosa",
        lat: 2.946318,
        lng: 101.849056,
    },
    {
        name: "Bukit Dukung",
        lat: 3.03526595,
        lng: 101.7696251,
    },
    {
        name: "Kg. Sg. Pening",
        lat: 3.0099934499999996,
        lng: 101.8642072,
    },
    // {
    //     name: "Kg. Sg. Jernih",
    //     lat: 3.0099934499999996,
    //     lng: 101.8642072,
    // },
    {
        name: "Kg. Sg. Kantan",
        lat: 3.0034065,
        lng: 101.78997755,
    },
    {
        name: "Jalan Reko",
        lat: 2.9667662999999997,
        lng: 101.79029129999999,
    },
    {
        name: "Kg. Rinching",
        lat: 2.905588,
        lng: 101.81592454999999,
    },
    {
        name: "Sesapan Batu Rembau",
        lat: 2.8829380500000004,
        lng: 101.876405,
    },
    {
        name: "Sesapan Batu Minangkabau",
        lat: 2.8866512,
        lng: 101.882038,
    },
]